import { Skeleton } from '@nest/uikit-react';
import React from 'react';

export const TerminalListRow = React.memo(({ label, count, isLoading, onClick }: { label: string; count?: number; isLoading?: boolean; onClick: () => void }) => {
	return (
		<button
			type="button"
			onClick={onClick}
			className="w-full rounded-md border bg-background px-3 py-3 text-left shadow-sm transition-colors hover:bg-muted/50 active:bg-muted"
		>
			<div className="flex items-center justify-between gap-3">
				<span className="truncate text-base font-medium">{label}</span>

				{isLoading ? (
					<Skeleton className="h-6 w-10 rounded-full" />
				) : (
					<span className="inline-flex h-6 shrink-0 items-center justify-center rounded-full border px-2 text-sm font-semibold">{count ?? 0}</span>
				)}
			</div>
		</button>
	);
});
